module.exports = "/images/email.svg?41904d2dbd2e32f2c7271d4ca0af922e";